import { Checkbox, FormControlLabel, Grid, useEventCallback } from '@mui/material';
import { memo } from 'react';
import { AccordionCivilStatusMutation } from 'mutation/view-models/civil-status';
import { FormikTouched, FormikErrors } from 'formik';
import CivilStatusList from 'shell/components/shared/civil-status-list';

interface FormCivilStatusProps {
  errors?: FormikErrors<AccordionCivilStatusMutation>;
  touched?: FormikTouched<AccordionCivilStatusMutation>;
  values?: AccordionCivilStatusMutation;
  onChange: (
    key: keyof AccordionCivilStatusMutation,
    value: AccordionCivilStatusMutation[keyof AccordionCivilStatusMutation]
  ) => void;
  disabled?: boolean;
}

const FormCivilStatusComponent = ({
  values,
  onChange,
  errors,
  touched,
  disabled,
}: FormCivilStatusProps): React.ReactElement => {
  const handleCivilStatusListChange = useEventCallback((element: string | undefined) => {
    onChange('oldStatus', element);
  });

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={6}>
        <CivilStatusList
          label="Stato civile"
          aria-label="Stato civile"
          value={values?.oldStatus || ''}
          onChange={handleCivilStatusListChange}
          error={touched?.oldStatus && Boolean(errors?.oldStatus)}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs>
        <FormControlLabel
          control={
            <Checkbox
              id="availableStatus"
              checked={values?.available || false}
              onChange={() => onChange('available', !values?.available)}
              inputProps={{ 'aria-label': 'Stato civile non disponibile' }}
              disabled={disabled}
            />
          }
          label="Stato civile non disponibile"
        />
      </Grid>
    </Grid>
  );
};

FormCivilStatusComponent.displayName = 'Form civil status component';

const FormCivilStatus = memo(FormCivilStatusComponent);

export default FormCivilStatus;
